import { GridColumnConfig } from '../../models/gridCoumnConfig';

export const billingReportColumns: GridColumnConfig[] = [
  {
    title: 'Customer Name',
    field: 'customerName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Office Name',
    field: 'officeName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Project Name',
    field: 'projectName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Lot/Unit#',
    field: 'unitName',
    filter: 'text',
    width: '220',
    searchable: true,
  },
  {
    title: 'Work Order #',
    field: 'workOrderNumber',
    filter: 'text',
    width: '180',
    searchable: true,
  },
  {
    title: 'Work Order Status',
    field: 'workorderstatus',
    filter: 'text',
    width: '180',
    searchable: true,
    // navigate: true,
  },
  {
    title: 'Inspection Requested From',
    field: 'inspectionRequestedFrom',
    filter: 'text',
    width: '250',
    searchable: true,
  },
  {
    title: 'Inspection Requested On',
    field: 'inspectionRequestedON',
    filter: 'text',
    width: '250',
    searchable: true,
  },
  {
    title: 'Inspection Completed Date',
    field: 'inspection_Completed_Date',
    filter: 'text',
    width: '250',
    searchable: true,
  },
  {
    title: 'Completed Date',
    field: 'completed_Date',
    filter: 'text',
    width: '220',
    searchable: true,
  },

  {
    title: 'Inspection Requested By',
    field: 'inspectionRequestedBy',
    filter: 'text',
    width: '250',
    searchable: true,
  },
  {
    title: 'Inspection Request Type',
    field: 'inspectionRequestType',
    filter: 'text',
    width: '250',
    searchable: true,
  },
];
